import type { ConsumptionMode, ToolRecord } from './compare'

export function isConsumptionModePublished(tool: ToolRecord, mode: ConsumptionMode): boolean {
  return mode === 'average' ? tool.averageCfm !== null : tool.loadCfm !== null
}

export function modeAfterDirectToolSelection(
  tool: ToolRecord,
  currentMode: ConsumptionMode,
): ConsumptionMode {
  if (tool.averageCfm !== null && tool.loadCfm !== null) return 'average'
  if (isConsumptionModePublished(tool, currentMode)) return currentMode
  if (tool.averageCfm !== null) return 'average'
  if (tool.loadCfm !== null) return 'load'
  return currentMode
}
